<body>
  <div class="h-100">
    <!-- Toast container to stack multiple toasts -->
    <div class="toast-container">
      <!--Toaster for success message-->
      <div class="toast-item toast-success" *ngIf="showSuccess" [@toastAnimation]>
        <div class="toast-wrapper ps-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <img width="20" src="assets/images/toastr/tost-success.svg" alt="Success" />
            <div class="content ms-3">
              <h6 class="mb-0">Success</h6>
              <p class="mb-0">{{ successMsg }}</p>
            </div>
          </div>
          <button class="btn close-btn" (click)="closeSuccessToast()">
            <img width="18" src="assets/images/toastr/ic_close.svg" alt="Close" />
          </button>
        </div>
        <!-- Progress bar -->
        <div class="toast-progress">
          <div class="progress-bar progress-success"></div>
        </div>
      </div>

      <!--Toaster for client-side error message (4xx)-->
      <div class="toast-item toast-error client-error" *ngIf="showClientError" [@toastAnimation]>
        <div class="toast-wrapper ps-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <img width="20" src="assets/images/toastr/tost-error.svg" alt="Error" />
            <div class="content ms-3">
              <h6 class="mb-0">Validation Error</h6>
              <p class="mb-0">{{ clientErrorMsg }}</p>
            </div>
          </div>
          <button class="btn close-btn" (click)="closeClientErrorToast()">
            <img width="18" src="assets/images/toastr/ic_close.svg" alt="Close" />
          </button>
        </div>
        <!-- Progress bar -->
        <div class="toast-progress">
          <div class="progress-bar progress-error"></div>
        </div>
      </div>

      <!--Toaster for server-side error message (5xx)-->
      <div class="toast-item toast-error server-error" *ngIf="showServerError" [@toastAnimation]>
        <div class="toast-wrapper ps-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <img width="20" src="assets/images/toastr/tost-error.svg" alt="Server Error" />
            <div class="content ms-3">
              <h6 class="mb-0">Server Error</h6>
              <p class="mb-0">{{ serverErrorMsg }}</p>
            </div>
          </div>
          <button class="btn close-btn" (click)="closeServerErrorToast()">
            <img width="18" src="assets/images/toastr/ic_close.svg" alt="Close" />
          </button>
        </div>
        <!-- Progress bar -->
        <div class="toast-progress">
          <div class="progress-bar progress-error"></div>
        </div>
      </div>

      <!--Toaster for processing message-->
      <div class="toast-item toast-processing" *ngIf="showProcessing" [@toastAnimation]>
        <div class="toast-wrapper ps-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <div class="content ms-3">
              <h6 class="mb-0">Processing</h6>
              <p class="mb-0">{{ processMsg }}</p>
            </div>
          </div>
          <button class="btn close-btn" (click)="closeProcessingToast()">
            <img width="18" src="assets/images/toastr/ic_close.svg" alt="Close" />
          </button>
        </div>
      </div>
    </div>
    <app-navigation-menu></app-navigation-menu>
  </div>
</body>